var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModuleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 1H1V17H19V1ZM0 0V18H20V0H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12V5.99998H5V12H4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.94252C11 9.93295 10.7183 10.6908 10.1548 11.2161C9.59125 11.7387 8.77965 12 7.71993 12H6V5.99998H7.90076C8.87917 5.99998 9.64031 6.25716 10.1842 6.77152C10.7281 7.28589 11 8.00956 11 8.94252ZM9.94029 8.97536C9.94029 7.53897 9.25203 6.82077 7.87553 6.82077H7.00505V11.1751H7.71993C9.20017 11.1751 9.94029 10.4418 9.94029 8.97536Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.94252C17 9.93295 16.7183 10.6908 16.1548 11.2161C15.5913 11.7387 14.7796 12 13.7199 12H12V5.99998H13.9008C14.8792 5.99998 15.6403 6.25716 16.1842 6.77152C16.7281 7.28589 17 8.00956 17 8.94252ZM15.9403 8.97536C15.9403 7.53897 15.252 6.82077 13.8755 6.82077H13.005V11.1751H13.7199C15.2002 11.1751 15.9403 10.4418 15.9403 8.97536Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleIcon);
export default __webpack_public_path__ + "static/media/moduleIcon.9b0bc2b36a182cb03b65dab3d3475951.svg";
export { ForwardRef as ReactComponent };